import { DEFAULT_FILTERS } from './constants';
import { SET_FILTER, RESET_FILTERS, SET_PAGE, SET_CATEGORY_NAMES } from './actions';
import { getFiltersFromURL } from '../utils/helpers';

function getInitialState() {
	const filters = typeof window === 'undefined'
		? { ...DEFAULT_FILTERS }
		: { ...DEFAULT_FILTERS, ...getFiltersFromURL() };
	return { ...filters, categoryNames: {} };
}

export default function reducer( state = getInitialState(), action ) {
	switch ( action.type ) {
		case SET_FILTER:
			return { ...state, [ action.key ]: action.value, page: 1 };
		case SET_PAGE:
			return { ...state, page: action.page };
		case RESET_FILTERS:
			// Preserve categoryNames across filter resets — names don't change when filters clear.
			return { ...DEFAULT_FILTERS, categoryNames: state.categoryNames };
		case SET_CATEGORY_NAMES:
			return { ...state, categoryNames: { ...state.categoryNames, ...action.names } };
		default:
			return state;
	}
}
